/* tslint:disable */
/* eslint-disable */
/* @relayHash d95b7720a8eefa922b4617be554ac638 */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedConsumerSourcingModalDisplayHelpersQueryVariables = {
    itemId: string;
};
export type pdpSharedConsumerSourcingModalDisplayHelpersQueryResponse = {
    readonly viewer: {
        readonly item: {
            readonly pricing: {
                readonly retailPrice: {
                    readonly convertedAmounts: {
                        readonly USD: number | null;
                    } | null;
                } | null;
            } | null;
        } | null;
    };
};
export type pdpSharedConsumerSourcingModalDisplayHelpersQuery = {
    readonly response: pdpSharedConsumerSourcingModalDisplayHelpersQueryResponse;
    readonly variables: pdpSharedConsumerSourcingModalDisplayHelpersQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pricing",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPricing",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "retailPrice",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "convertedAmounts",
          "storageKey": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "USD",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedConsumerSourcingModalDisplayHelpersQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedConsumerSourcingModalDisplayHelpersQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedConsumerSourcingModalDisplayHelpersQuery",
    "id": "app-buyer-finding/254.0.0-2020-03-04T19:26:20.366Z/pdpSharedConsumerSourcingModalDisplayHelpersQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0122baa1b68478234f8f1da77d3ea7c8';
export default node;
